// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__15iW2","requiredAsterisk":"Info_requiredAsterisk__Ac0Kl"};